import { API_URL } from '../../../app-config/constants';
import type CustomizationDto from '../../../types/CustomizationDto';
import type { ReplacementKey } from '../../react/services/Replacement';
import { get, put } from '../request';

const BASE = `${API_URL}/replacements`;

export function getDefaults() {
    return get<{ [key in ReplacementKey]: string }>(`${BASE}/defaults`);
}

export function getCustomizations() {
    return get<CustomizationDto>(`${BASE}/customizations`);
}

export function updateCustomizations(customizations: Partial<{ [key in ReplacementKey]: string }>) {
    return put(`${BASE}/customizations`, { postData: customizations });
}

// Company Observer

export function getCurrentCustomizations() {
    return get<{ [key in ReplacementKey]: string }>(BASE);
}

export function getCustomizationsForCompany(companyId: string) {
    return get<CustomizationDto>(`${BASE}/${companyId}/customizations`);
}

export function updateCustomizationsForCompany(
    companyId: string,
    customizations: Partial<{ [key in ReplacementKey]: string }>
) {
    return put(`${BASE}/${companyId}/customizations`, { postData: customizations });
}
